import { TextInputFormikPropTypes, TextInputFormikDefaultProps } from '../../Utils/TextInputPropTypes';

export const InputEmailPropTypes = TextInputFormikPropTypes;

export const InputEmailDefaultProps = TextInputFormikDefaultProps;

export default { InputEmailPropTypes, InputEmailDefaultProps };
